import React from "react";
import theme from "app/Theme/Theme";
import Svg, { Path } from "react-native-svg";

const CarotIcon = ({
  height = 16,
  width = 9,
  color = theme.colors["brand.500"],
  ...props
}) => (
  <Svg
    width={width}
    height={height}
    {...props}
    viewBox="0 0 9 16"
    preserveAspectRatio="xMidYMin meet"
  >
    <Path
      d="M0.0898438 0.849609H8.59863L0.0898438 15.4326V0.849609Z"
      fill={color}
    />
  </Svg>
);

export default CarotIcon;
